<template>
  <div>
    <template-list :document-type="2" :value.sync="editedDelegationOrder" />
    <h1>
      {{ $t("delegationOrder.form.title") }}
      <delegation-order-travel-service-import :travel_service_order_ids.sync="editedDelegationOrder.travel_service_order_ids" />
    </h1>
    <div class="mt-3 elevation-12 white">
      <v-container class="pa-4" fluid>
        <v-form ref="form">
          <v-row dense>
            <v-col md="6" sm="6" cols="12">
              <v-autocomplete
                :error-messages="translatedErrors.user_id"
                :items="users"
                :label="$t('delegation.form.fields.delegated.name')"
                item-text="fullName"
                item-value="id"
                v-model="contextUserId"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col md="6" sm="6" cols="12" v-if="companies.length > 1">
              <v-autocomplete
                :error-messages="translatedErrors.company_id"
                :items="companies"
                :label="$t('delegation.form.fields.company.name')"
                item-text="name"
                item-value="id"
                v-model="editedDelegationOrder.company_id"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-tooltip :disabled="$store.state.Auth.userProperties.system_settings.delegation_order_number_setting_type !== 2" top>
                <template #activator="{on}">
                  <v-text-field
                    v-on="on"
                    :disabled="$store.state.Auth.userProperties.system_settings.delegation_order_number_setting_type === 3"
                    :error-messages="translatedErrors.custom_number"
                    :label="$t('delegationOrder.form.fields.number.name')"
                    :placeholder="
                      $store.state.Auth.userProperties.system_settings.delegation_order_number_setting_type !== 1
                        ? $t('delegation.form.fields.delegationNumber.willBeAuto')
                        : null
                    "
                    :readonly="$store.state.DelegationOrder.readonly === true"
                    v-model="editedDelegationOrder.custom_number"
                  />
                </template>
                {{ $t("delegation.form.fields.delegationNumber.leftEmptyToAutomatic") }}
              </v-tooltip>
            </v-col>
            <template v-if="$store.getters['userProperties'].system_settings.is_delegation_task_enabled === 2">
              <v-col md="6" sm="6" cols="12">
                <v-select
                  :error-messages="translatedErrors.task_id"
                  :items="delegation_tasks"
                  :label="$t('delegation.form.fields.task.name')"
                  v-model="editedDelegationOrder.task_id"
                  :readonly="$store.state.DelegationOrder.readonly === true"
                />
              </v-col>
              <v-col md="6" sm="6" cols="12">
                <v-text-field
                  :error-messages="translatedErrors.task"
                  :label="$t('delegation.form.fields.taskDescription.name')"
                  v-model="editedDelegationOrder.task"
                  :readonly="$store.state.DelegationOrder.readonly === true"
                />
              </v-col>
            </template>
            <v-col cols="12">
              <delegation-order-travel-service :travel-service-order-ids.sync="editedDelegationOrder.travel_service_order_ids" />
            </v-col>
            <v-col cols="12" v-if="companies.length < 2">
              <location-ajax-select-multiple
                :defaultItems="editedDelegationOrder.destinationObjects"
                :label="$t('delegation.form.fields.destination.name')"
                :placeholder="editedDelegationOrder.destinationText"
                :select-model.sync="editedDelegationOrder.destination"
                :select-text.sync="editedDelegationOrder.destinationText"
                :readonly="$store.state.DelegationOrder.readonly === true"
                :multiple="true"
                v-bind:select-validation="translatedErrors.destination"
              />
            </v-col>
            <v-col cols="12" md="6" sm="6" v-if="companies.length > 1">
              <location-ajax-select-multiple
                :defaultItems="editedDelegationOrder.destinationObjects"
                :label="$t('delegation.form.fields.destination.name')"
                :placeholder="editedDelegationOrder.destinationText"
                :select-model.sync="editedDelegationOrder.destination"
                :select-text.sync="editedDelegationOrder.destinationText"
                :readonly="$store.state.DelegationOrder.readonly === true"
                :multiple="true"
                v-bind:select-validation="translatedErrors.destination"
              />
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-tooltip top>
                <template #activator="{on}">
                  <location-ajax-select
                    :default-items="defaultStartEndLocation"
                    :label="$t('delegationOrder.form.fields.startPlace.name')"
                    :placeholder="editedDelegationOrder.start_place_text"
                    :select-model.sync="editedDelegationOrder.start_place_id"
                    :select-text.sync="editedDelegationOrder.start_place_text"
                    :readonly="$store.state.DelegationOrder.readonly === true"
                    v-on="on"
                    v-model="editedDelegationOrder.start_place_id"
                  />
                </template>
                {{ $t("delegationOrder.form.leftEmptyToSetDefaultPlace") }}
              </v-tooltip>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-tooltip top>
                <template #activator="{on}">
                  <location-ajax-select
                    :default-items="defaultStartEndLocation"
                    :label="$t('delegationOrder.form.fields.endPlace.name')"
                    :placeholder="editedDelegationOrder.end_place_text"
                    :select-model.sync="editedDelegationOrder.end_place_id"
                    :select-text.sync="editedDelegationOrder.end_place_text"
                    :readonly="$store.state.DelegationOrder.readonly === true"
                    v-on="on"
                    v-model="editedDelegationOrder.end_place_id"
                  />
                </template>
                {{ $t("delegationOrder.form.leftEmptyToSetDefaultPlace") }}
              </v-tooltip>
            </v-col>
            <v-col cols="6" v-if="isReInvoicingForExternalContractorModuleEnabled">
              <v-autocomplete
                :items="externalCustomers"
                v-model="editedDelegationOrder.external_customer_id"
                :error-messages="translatedErrors.external_customer_id"
                :clearable="$store.state.DelegationOrder.readonly !== true"
                :readonly="$store.state.DelegationOrder.readonly === true"
                :label="$t('delegation.form.fields.externalCustomer.name')"
                @change="changedExternalCustomer"
              />
            </v-col>
            <v-col cols="6" v-if="isReInvoicingForExternalContractorModuleEnabled">
              <v-autocomplete
                :items="projectsForExternalCustomer"
                v-model="editedDelegationOrder.project_id"
                :clearable="$store.state.DelegationOrder.readonly !== true"
                :label="$t('delegation.form.fields.project.name')"
                :error-messages="translatedErrors.project_id"
                persistent-hint
                :readonly="$store.state.DelegationOrder.readonly === true"
                :hint="
                  editedDelegationOrder.project_id === null
                    ? ''
                    : $t('global.orderNumber') + ': ' + projects.find(v => v.value === editedDelegationOrder.project_id).order_number
                "
              />
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <date-time-picker-model-computed
                :date-label="$t('delegationOrder.form.fields.startDate.dateLabel')"
                :date-time-validation="translatedErrors.start_date"
                :dateTimeModel.sync="editedDelegationOrder.start_date"
                :time-label="$t('delegationOrder.form.fields.startDate.timeLabel')"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <date-time-picker-model-computed
                :date-label="$t('delegationOrder.form.fields.endDate.dateLabel')"
                :date-time-validation="translatedErrors.end_date"
                :dateTimeModel.sync="editedDelegationOrder.end_date"
                :time-label="$t('delegationOrder.form.fields.endDate.timeLabel')"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col md="12" sm="12" cols="12">
              <delegation-order-restrictions
                :allowed-transport-cost-model.sync="editedDelegationOrder.allowed_transport_cost"
                :allowed-transport-model.sync="editedDelegationOrder.allowed_transport"
              />
            </v-col>

            <v-col md="12" sm="12" cols="12">
              <collapse-simple-advance-panel
                :clearable="$store.state.DelegationOrder.readonly !== true"
                :addable="$store.state.DelegationOrder.readonly !== true"
                :model-advances.sync="editedDelegationOrder.advances"
                v-on:addAdvanceItem="addDelegationAdvance"
                v-on:removeAdvanceItem="removeAdvance"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <date-picker
                :label="$t('delegationOrder.form.fields.settlementDeadline.name')"
                :model.sync="editedDelegationOrder.settlement_deadline"
                v-bind:placeholder="defaultSettlementDate"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col v-if="$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== 3" cols="6">
              <v-select
                :error-messages="translatedErrors.cost_centre_id"
                :items="availableCostCentres"
                :label="$t('delegation.form.fields.costCentre.name')"
                :clearable="$store.state.DelegationOrder.readonly !== true"
                item-text="name"
                item-value="id"
                v-model="editedDelegationOrder.cost_centre_id"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col>
              <amount-input
                :error-messages="translatedErrors.overall_estimated"
                :model.sync="editedDelegationOrder.estimated_total_cost"
                :label="$t('delegationOrder.form.fields.estimatedTotalCost.name')"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text v-if="$store.state.DelegationOrder.readonly !== true">
            {{ editedDelegationOrder.id === null ? $t("global.add") : $t("global.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import DatePicker from "../CustomInputComponents/DatePicker.vue";
import DateTimePickerModelComputed from "../CustomInputComponents/DateTimePickerModelComputed.vue";
import Currency from "../../staticData/CurrencyTypes";
import LocationAjaxSelect from "../CustomInputComponents/LocationAjaxSelect.vue";
import delegationOrderModel from "../../models/delegationOrder";
import createErrorArray from "../../repository/errorArray";
import CollapseSimpleAdvancePanel from "../Advance/CollapseSimpleAdvancePanel.vue";
import objectTranslations from "../../repository/translateStringsInObject";
import DelegationOrderRestrictions from "./DelegationOrderRestrictions";
import TemplateList from "../TemplateList";
import LocationAjaxSelectMultiple from "../CustomInputComponents/LocationAjaxSelectMultiple";
import DelegationOrderTravelServiceImport from "./DelegationOrderTravelServiceImport";
import DelegationOrderTravelService from "./DelegationOrderTravelService";
import AmountInput from "../CustomInputComponents/AmountInput";

//const errors = JSON.parse(JSON.stringify(createErrorArray(delegationOrderModel)));
const errors = createErrorArray(delegationOrderModel);

const _ = require("lodash");

export default {
  name: "DelegationOrderForm",
  components: {
    AmountInput,
    DelegationOrderTravelService,
    DelegationOrderTravelServiceImport,
    LocationAjaxSelectMultiple,
    TemplateList,
    DelegationOrderRestrictions,
    LocationAjaxSelect,
    DatePicker,
    DateTimePickerModelComputed,
    CollapseSimpleAdvancePanel
  },
  data: () => ({
    formControls: {
      settlementDatetimePicker: false,
      startTimePicker: false,
      startDatePicker: false,
      endTimePicker: false,
      endDatePicker: false,
      customPanel: [false]
      //customRules: false,
    },
    currency: Currency,
    formTitle: "",
    users: [],
    downloaded_delegation_tasks: [],
    editedItem: delegationOrderModel,
    errors: errors,
    snackbar: false,
    projects: [],
    externalCustomers: [],
    companies: []
  }),

  watch: {
    modelChange: function() {
      this.serverValidation();
    },
    datePickerPickedDate: function(oldModel, newModel) {
      if (newModel === true) {
        this.formControls.startTimePicker = true;
      }
    }
  },

  computed: {
    isReInvoicingForExternalContractorModuleEnabled() {
      return this.$store.getters["userProperties"].system_settings.external_customers_module === 2;
    },
    availableCostCentres() {
      let userProperties = this.users.find(v => parseInt(v.id) === parseInt(this.editedDelegationOrder.user_id));
      if (userProperties != null) {
        return userProperties.availableCostCentres;
      }
      return [];
    },
    delegation_tasks() {
      let result = [];
      for (let delegationTask of this.downloaded_delegation_tasks) {
        result.push({
          value: delegationTask.id,
          text: this.$i18n.locale === "pl" || delegationTask.name_en == null || delegationTask.name_en.length < 1 ? delegationTask.name : delegationTask.name_en
        });
      }
      return result;
    },
    translatedErrors() {
      let translatedErrors = JSON.parse(JSON.stringify(this.errors));
      translatedErrors = objectTranslations(translatedErrors);
      return translatedErrors;
    },
    defaultSettlementDate: function() {
      if (this.editedDelegationOrder.end_date) {
        let date = new Date(this.editedDelegationOrder.end_date.substring(0, 10));
        date.setDate(date.getDate() + 14);
        return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
      }
      return null;
    },
    datePickerPickedDate: function() {
      return this.formControls.startDatePicker;
    },
    modelChange: function() {
      for (let property in this.editedDelegationOrder) this.editedDelegationOrder[property]; //deep object watcher hack
      return this.editedDelegationOrder;
    },
    editedDelegationOrder: {
      get() {
        // if (this.$store.getters["DelegationOrder/delegationOrderEdited"] != null) {
        //   this.editedItem = this.$store.getters["DelegationOrder/delegationOrderEdited"];
        // }
        return this.$store.getters["DelegationOrder/delegationOrderEdited"];
      },
      set(value) {
        this.$store.commit("DelegationOrder/setEditedDelegationOrder", value); // this.$store.state.DelegationOrder.delegationOrderEdited = value;
      }
    },
    defaultStartEndLocation() {
      let userData = this.users.find(value => value.id.toString() === this.editedDelegationOrder.user_id || value.id === this.editedDelegationOrder.user_id);
      let result = [];
      if (typeof userData != "undefined" && userData.workLocationId !== null) {
        result.push({
          value: userData.workLocationId,
          text: this.$t("global.workLocation") + ": " + userData.workLocationText
        });
      }
      if (typeof userData != "undefined" && userData.homeLocationId !== null) {
        result.push({
          value: userData.homeLocationId,
          text: this.$t("global.homeLocation") + ": " + userData.homeLocationText
        });
      }
      return result;
    },
    contextUserId: {
      get() {
        return parseInt(this.editedDelegationOrder.user_id);
      },
      set(value) {
        if (this.users.length > 0) {
          if (this.editedDelegationOrder.user_id !== null) {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("delegationOrder.form.userChanged"),
              color: "info",
              position: "down"
            });
          }
          this.editedDelegationOrder.user_id = value;
          let userProperties = this.users.find(v => v.id === value);
          if (userProperties != null) {
            this.editedDelegationOrder.company_id = userProperties.companyId;
            if (userProperties.defaultCostCentre != null) {
              this.editedDelegationOrder.cost_centre_id = userProperties.defaultCostCentre.id;
            } else {
              this.editedDelegationOrder.cost_centre_id = null;
            }
          }
        }
      }
    },
    projectsForExternalCustomer() {
      return this.projects.filter(v => v.external_customer_id === this.editedDelegationOrder.external_customer_id);
    }
  },
  methods: {
    isFormChanged() {
      return (
        JSON.stringify(this.$store.state.DelegationOrder.delegationOrderEdited) !== JSON.stringify(this.$store.state.DelegationOrder.nonChangedDelegationOrder)
      );
    },
    beforeRouteLeave(from, to, next) {
      if (from.fullPath === "/logout") {
        next();
      } else if (this.isFormChanged()) {
        let result = this.$store.dispatch("confirmDialog", {
          content: this.$t("global.saveBeforeExit.content"),
          title: this.$t("global.saveBeforeExit.title"),
          customButtons: [
            { text: this.$t("global.cancel"), value: "cancel" },
            { text: this.$t("global.no"), value: "no" },
            { text: this.$t("global.yes"), color: "primary", value: "yes" }
          ]
        });
        result.then(chosen => {
          if (chosen === "cancel") {
            next(false);
          } else if (chosen === "no") {
            next();
          } else if (chosen === "yes") {
            this.save();
          }
        });
      } else {
        next();
      }
    },
    changedExternalCustomer() {
      this.editedDelegationOrder.project_id = null;
    },
    addDelegationAdvance() {
      if (this.$store.state.DelegationOrder.readonly !== true) {
        this.$store.dispatch("DelegationOrder/addAdvance");
      }
    },
    save() {
      if (!this.isValidModel()) {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.error.canNotSaveErrorsInForm"),
          color: "error"
        });
        return false;
      }
      this.$store.dispatch("DelegationOrder/saveChanges", this.editedDelegationOrder).then(() => {
        this.$router.push("/delegation-order");
      });
    },
    cancel() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.exitConfirm.content"),
        title: this.$t("global.exitConfirm.title")
      });
      result.then(() => {
        this.$router.push("/delegation-order");
        this.$store.dispatch("DelegationOrder/cancelChanges", this.editedDelegationOrder);
      });
    },
    isValidModel() {
      for (let property in this.errors) {
        if (this.errors[property].length > 0) {
          return false;
        }
      }
      return true;
    },
    removeAdvance(item) {
      if (this.$store.state.DelegationOrder.readonly !== true) {
        this.$store.dispatch("DelegationOrder/removeAdvance", item);
      }
    },
    serverValidation: _.debounce(function() {
      if (this.editedDelegationOrder.allowed_transport.length > 0) {
        this.formControls.customPanel[0] = true;
      }
      this.axios({
        url: "delegation-order/validate",
        data: this.editedDelegationOrder,
        method: "POST"
      })
        .then(resp => {
          for (let property in this.editedDelegationOrder) {
            this.errors[property] = [];
          }
          for (const propertyName in resp.data) {
            for (const i in resp.data[propertyName]) {
              this.errors[propertyName].push(resp.data[propertyName][i]);
            }
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    }, 300)
  },
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.$store.dispatch("DelegationOrder/editDelegationOrder", this.$route.params.id);
    }
    this.axios.get("delegation/get-delegations-select-data").then(response => {
      this.downloaded_delegation_tasks = response.data.tasks;
      this.externalCustomers = response.data.external_customers;
      this.projects = response.data.projects;
      this.companies = response.data.companies;
    });
    this.axios.get("delegation-order/available-users").then(response => {
      this.users = response.data;
    });
    // this.axios.get("delegation/get-available-task").then(response => {
    //   this.downloaded_delegation_tasks = response.data;
    // });
    if (this.$store.getters["DelegationOrder/delegationOrderEdited"] == null) {
      this.$store.dispatch("DelegationOrder/newTripStart");
    }
    this.serverValidation();
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
